"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonTabs = void 0;
const React = require("react");
const BronsonTabs = (props) => {
    const [activeTab, setActiveTab] = React.useState();
    React.useEffect(() => {
        props.default && setActiveTab(props.default);
    }, [props.default]);
    return (React.createElement("div", { className: 'c-tabs js-tabs' },
        React.createElement("nav", null,
            React.createElement("ul", { className: 'c-tabs__nav  js-tabs__nav ' }, props.tabs.map((tab) => (React.createElement("li", { key: `tabs-control-${tab.id}`, className: 'c-tabs__nav-item' },
                React.createElement("button", { title: tab.tooltip, id: `tabs-control-${tab.id}`, "aria-expanded": activeTab === tab.id, className: `c-tabs__nav-link js-tabs__nav-link ${activeTab === tab.id
                        ? 'is-panelbutton-opener is-active'
                        : ''}`, onClick: () => {
                        setActiveTab(tab.id);
                        props.onToggleTab &&
                            props.onToggleTab(tab.id);
                    } },
                    React.createElement("span", { className: 'c-tabs__text' }, tab.title))))))),
        React.createElement("div", null, props.tabs.map((tab) => (React.createElement("div", { key: `tabs-content-${tab.id}`, id: `tabs-content-${tab.id}`, "aria-hidden": activeTab !== tab.id, className: 'c-tabs__content  js-tabs__content' }, tab.content))))));
};
exports.BronsonTabs = BronsonTabs;
